var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20 2C21.1 2 22 2.9 22 3.99999V20C22 21.1 21.1 22 20 22H3.99999C2.9 22 2 21.1 2 20V3.99999C2 2.9 2.9 2 3.99999 2H20ZM12 6.00001C11.35 6.00001 10.78 6.40002 10.55 7.00002L6.90001 16.7C6.67002 17.33 7.13 18 7.80001 18H7.82C8.22001 18 8.58001 17.74 8.72 17.37L9.57999 14.94H14.42L15.27 17.36C15.41 17.74 15.77 18 16.18 18H16.19C16.86 18 17.33 17.33 17.09 16.7L13.45 7.00002C13.22 6.40002 12.65 6.00001 12 6.00001ZM12.05 8.23002L13.79 13.19H10.2L11.95 8.23002H12.05H12.05Z",
    fill: "#001B53"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText);
export default __webpack_public_path__ + "static/media/Text.5317efbc135c64453a4f06506d9e77d0.svg";
export { ForwardRef as ReactComponent };